import { render, staticRenderFns } from "./HistEquipo.vue?vue&type=template&id=063ace4e&"
import script from "./HistEquipo.vue?vue&type=script&lang=js&"
export * from "./HistEquipo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports